function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const DEFAULT_ID_PREFIX = 'text_form_field';
export function TextFormFieldRow(_ref) {
  let {
    fieldName,
    label,
    value,
    onChange = () => {},
    onBlur = () => {},
    as = 'input',
    placeholder = '',
    disabled = false,
    required = false,
    size = 'md',
    labelColSpan = 3,
    id: idProp,
    dataTestId,
    marginClass = 'mb-2',
    formGroupClasses = '',
    renderLabel = true,
    fieldStyle = {}
  } = _ref;
  const {
    t
  } = useTranslation();
  const id = idProp !== null && idProp !== void 0 ? idProp : "".concat(DEFAULT_ID_PREFIX, "_").concat(fieldName).replace(/\./g, '_');
  const testId = dataTestId !== null && dataTestId !== void 0 ? dataTestId : id;
  if (dataTestId == null || dataTestId === '') {
    console.error('TextFormFieldRow: dataTestId is required for accessible testing. ' + "Provide dataTestId for fieldName \"".concat(fieldName, "\". Using fallback \"").concat(testId, "\" for now."));
  }
  const commonControlProps = {
    id,
    name: fieldName,
    value,
    onChange,
    size,
    disabled,
    'data-testid': testId
  };
  const labelContent = /*#__PURE__*/React.createElement(React.Fragment, null, t("".concat(label || fieldName)), required ? '*' : '');
  const control = /*#__PURE__*/React.createElement(Form.Control, _extends({
    as: as,
    type: "text",
    placeholder: placeholder,
    onBlur: onBlur,
    style: fieldStyle
  }, commonControlProps));
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "".concat(marginClass, " TextFormFieldRow TextFormFieldRow-").concat(fieldName, " ").concat(formGroupClasses),
    as: Row
  }, renderLabel && /*#__PURE__*/React.createElement(Form.Label, {
    className: "TextFormFieldRow-FormLabel",
    column: "md",
    md: labelColSpan,
    htmlFor: id
  }, labelContent), /*#__PURE__*/React.createElement(Col, null, control));
}